import { IconButton } from '@mui/material';
import spacing, { isMobileScreen } from '../../../theme/spacing';
import { FaXMarkLightSvgIcon } from '../../../assets/icons/svgs';
import { fontSize } from '../../../theme/typography';
import { colors } from '../../../theme/colors';
import { TOP_MENU_BAR_HEIGHT } from '../../TopMenuBar.tsx/constants';

const CloseModalButton = ({ onModalClose }: { onModalClose?: () => void }) => {
  if (!onModalClose || !isMobileScreen) {
    return null;
  }

  return (
    <IconButton
      onClick={onModalClose}
      style={{
        padding: spacing.medium,
      }}
    >
      <FaXMarkLightSvgIcon
        size={fontSize['2xl'] + 4}
        fill={colors.textPrimary}
      />
    </IconButton>
  );
};

const ModalBigTitleBar = ({
  title,
  onModalClose,
  RightSideActionComponent,
  titleStyles,
}: {
  title?: string;
  onModalClose?: () => void;
  RightSideActionComponent?: React.ReactNode;
  titleStyles?: React.CSSProperties;
}) => {
  if (!title) {
    return null;
  }

  const RightSideButton = () => {
    if (onModalClose) {
      return <CloseModalButton onModalClose={onModalClose} />;
    }

    if (RightSideActionComponent) {
      return <>{RightSideActionComponent}</>;
    }

    return null;
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
        height: TOP_MENU_BAR_HEIGHT,
        maxHeight: TOP_MENU_BAR_HEIGHT,
        minHeight: TOP_MENU_BAR_HEIGHT,
        background: colors.backgroundMedium,
      }}
    >
      <div
        style={{
          display: 'inline-block',
          fontSize: fontSize['2xl'],
          color: colors.textPrimary,
          fontWeight: 'bold',
          marginLeft: spacing.medium,
          ...titleStyles,
        }}
      >
        {title}
      </div>
      <div style={{ position: 'absolute', right: 0 }}>
        <RightSideButton />
      </div>
    </div>
  );
};

export default ModalBigTitleBar;
